/**
 * Copyright (C) 2017-2018 System Clinic Inc. All rights reserved.
 * This file is the property of System Clinic Inc.
 *
 * File: Footer.js
 * Author: Naoaki Suganuma
 * Update: 2018/3/12
 * Version: 1.0.0
 */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import blueGrey from '@material-ui/core/colors/blueGrey';
import grey from '@material-ui/core/colors/grey';
import withStyles from '@material-ui/core/styles/withStyles';
import withTheme from '../withTheme';
import gscPackage from '../../package.json';

/**
 * スタイル情報 
 */
const styles = theme => ({
  bar: {
    flexGrow: 1,
    backgroundColor: blueGrey[50]
  },
  info: {
    fontSize: "0.8em",
    textAlign: "left",
    marginLeft: 20
  },
  copyright: {
    fontSize: "0.8em",
    color: grey[500],
    textAlign: "right",
    marginRight: 20
  },
});

/**
 * Footerコンポーネント
 */
class Footer extends Component {
  /**
   * Footerのレンダリング
   */
  render() {
    return (
      <div>
        <Divider />
        <Grid container spacing={0} className={this.props.classes.bar}>
          <Grid item xs={6}>
            <Link to="/about" className={this.props.classes.info}>
              GLYPHSHOT {gscPackage.version}
            </Link>
          </Grid>
          <Grid item xs={6}>
            <div className={this.props.classes.copyright}>Copyright (c) OBAYASHI CORPORATION.</div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

/**
 * Themeの適用
 */
export default withTheme(withStyles(styles)(Footer))